// src/utils/debugTenantSetup.js
import { db } from '../config/firebase';
import { tenantService } from '../services/tenantService';

/**
 * Debug function to test tenant setup step by step
 */
export const debugTenantSetup = async () => {
  console.log('🔍 Starting tenant setup debugging...');
  
  try {
    // Step 1: Check Firebase connection
    console.log('1. Checking Firebase connection...');
    if (!db) {
      throw new Error('Firebase database not initialized');
    }
    console.log('✅ Firebase database is available');

    // Step 2: Test basic tenant service
    console.log('2. Testing tenant service...');
    const existingTenants = await tenantService.getAllTenants();
    console.log(`✅ Found ${existingTenants.length} existing tenants:`, existingTenants);

    // Step 3: Try creating a simple test tenant
    console.log('3. Creating test tenant...');
    const testTenant = {
      name: 'Test Clinic',
      slug: 'test-clinic',
      description: 'Test clinic for debugging',
      email: 'test@clinic.com',
      phone: '+44 123 456 789',
      address: {
        street: 'Test Street',
        city: 'Test City',
        postcode: 'T1 1ST',
        country: 'United Kingdom'
      },
      branding: {
        primaryColor: '#2563eb',
        secondaryColor: '#1e40af'
      }
    };

    const createdTenant = await tenantService.createTenant(testTenant);
    console.log('✅ Test tenant created successfully:', createdTenant);

    // Step 4: Clean up test tenant
    console.log('4. Cleaning up test tenant...');
    await tenantService.deleteTenant(createdTenant.id);
    console.log('✅ Test tenant cleaned up');

    console.log('🎉 All tests passed! Tenant setup should work.');
    return { success: true, message: 'All tests passed' };

  } catch (error) {
    console.error('❌ Debug test failed:', error);
    console.error('Error details:', {
      message: error.message,
      code: error.code,
      stack: error.stack
    });
    return { success: false, error: error.message };
  }
};

// Make it available in browser console
if (typeof window !== 'undefined') {
  window.debugTenantSetup = debugTenantSetup;
}
